import { HRM2010_R01Kpi } from './Util_HRM2010_R01';

/** 일일근태 KPI 칩의 입력 목록이다. */
interface Props {
    kpiList: HRM2010_R01Kpi[]; // 삭제 표시를 제외한 현재 목록에서 만든 칩
}

/** 조회된 일일근태의 인원·시간 요약을 칩으로 표시한다. */
export const KpiSection_HRM2010_R01 = ({ kpiList }: Props) => (
    <span className="flex flex-wrap items-center gap-1.5">
        {kpiList.map(kpi => (
            <span key={kpi.key} className="inline-flex items-baseline gap-1.5 rounded border border-gray-200 bg-gray-50 px-2 py-1">
                <span className="text-xs text-gray-500">{kpi.label}</span>
                <strong className={`text-sm ${kpi.tone === 'red' ? 'text-red-600' : kpi.tone === 'orange' ? 'text-amber-600' : 'text-gray-800'}`}>
                    {kpi.value}
                </strong>
            </span>
        ))}
    </span>
);
